
  import { Vue, Component, Prop } from "vue-property-decorator";
  import InputFilter from "@/components/filters/InputFilter.vue";
  

  @Component({
    components: {
      InputFilter,
    },
  })
  export default class Search extends Vue {
    @Prop({type: Number, default: undefined}) debounceTime!: number;
     @Prop({type: String, default: undefined}) placeholderText: string;
      @Prop({ type: String, default: "" }) readonly iconStyle!: string;
      @Prop({type: String, default: ""}) nameSearchStyle: string;

    search(search: string) {
      this.$emit("search", search);
    }
  }
